import axios from "axios";
import authHeader from "../services/auth-header";

export const resolveApiUrl = (rawUrl) => {
  const isLocal =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

  if (!rawUrl || typeof rawUrl !== "string") {
    return isLocal ? "http://localhost:8080/api/v1" : "";
  }

  // Strip accidental concatenated text (e.g. "... REACT_APP_API_TIMEOUT=60000")
  let cleaned = rawUrl.trim().split(/\s+/)[0];

  // If comma-separated URLs were provided (e.g. local and production in same string)
  if (cleaned.includes(",")) {
    const urls = cleaned.split(",").map((u) => u.trim()).filter(Boolean);
    if (isLocal) {
      const localUrl = urls.find((u) => u.includes("localhost") || u.includes("127.0.0.1"));
      cleaned = localUrl || urls[0];
    } else {
      const remoteUrl = urls.find((u) => !u.includes("localhost") && !u.includes("127.0.0.1"));
      cleaned = remoteUrl || urls[0];
    }
  }

  // Auto-correct if frontend domain was mistakenly entered instead of backend
  if (cleaned.includes("mtc-fs-fe.onrender.com")) {
    cleaned = cleaned.replace("mtc-fs-fe.onrender.com", "mtc-fs-be.onrender.com");
  }

  cleaned = cleaned.replace(/\/$/, "");

  if (!cleaned && isLocal) {
    return "http://localhost:8080/api/v1";
  }

  return cleaned;
};

const API_BASE = resolveApiUrl(process.env.REACT_APP_API_URL);

const http = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-type": "application/json",
  },
});

http.interceptors.request.use(
  (config) => {
    const auth = authHeader();
    if (auth && auth["x-access-token"]) {
      config.headers["x-access-token"] = auth["x-access-token"];
    }
    if (auth && auth["Authorization"]) {
      config.headers["Authorization"] = auth["Authorization"];
    }
    const viewAsRole = sessionStorage.getItem("mtc_view_as_role");
    if (viewAsRole) {
      config.headers["x-view-as-role"] = viewAsRole;
    }
    const viewAsUser = sessionStorage.getItem("mtc_view_as_user");
    if (viewAsUser) {
      config.headers["x-view-as-user"] = viewAsUser;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

// ── Response Interceptor: Session Invalidation & Expiry (401) ─────────────
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      try {
        localStorage.removeItem("user");
        localStorage.removeItem("lastActivityTime");
        sessionStorage.removeItem("mtc_view_as_role");
        sessionStorage.removeItem("mtc_view_as_user");
      } catch (e) {
        // ignore storage errors
      }

      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        const currentPath = window.location.pathname + window.location.search;
        window.location.href = `/login?expired=1&redirect=${encodeURIComponent(currentPath)}`;
      }
    }
    return Promise.reject(error);
  }
);

export default http;